/**
   * Get a query variable from the URL
   * As per https://css-tricks.com/snippets/javascript/get-url-variables/
   * params without a value will be set to true if they exist
   * @param variable
   * @returns {string|boolean}
   */
  function m3_getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return typeof pair[1] == 'undefined' ? true : pair[1];
      }
    }
    return false;
  }

export default m3_getQueryVariable